import React from "react";
import styled from "styled-components";
import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
  Marker as StandardMarker,
  MarkerAnchorPoint,
} from "@vis.gl/react-google-maps";

// Imported assets
import blueIcon from "../../../../assets/images/map/CircleIcon_Blue.svg";
import greenIcon from "../../../../assets/images/map/CircleIcon_Green.svg";
import redIcon from "../../../../assets/images/map/CircleIcon_Red.svg";
import yellowIcon from "../../../../assets/images/map/CircleIcon_Yellow.svg";

// Styled components
const MarkerIcon = styled.img`
  border-radius: 50%;
  height: 16px;
  width: 16px;
`;

const Marker = ({ data, index, position }) => {
  const determineMarkerColor = (locationStatus, maintenanceStatus) => {
    // if (locationStatus === "Cyber Attack") {
    //   return "yellow";
    // } else if (locationStatus === "Faulted") {
    //   return "red";
    // } else if (maintenanceStatus) {
    //   return "blue";
    // } else {
    //   // locationStatus === "Available" OR default
    //   return "green";
    // }
    if (locationStatus === "Cyber Attack") {
      return "yellow";
    } else if (maintenanceStatus) {
      return "blue";
    } else if (locationStatus === "Faulted") {
      return "red";
    } else {
      // locationStatus === "Available" OR default
      return "green";
    }
  };

  // Determines the icon for a marker based on the location's status
  const chooseMarkerIcon = (locationStatus, maintenanceStatus) => {
    // if (locationStatus === "Cyber Attack") {
    //   return yellowIcon;
    // } else if (locationStatus === "Faulted") {
    //   return redIcon;
    // } else if (maintenanceStatus) {
    //   return blueIcon;
    // } else {
    //   // locationStatus === "Available" OR default
    //   return greenIcon;
    // }
    if (locationStatus === "Cyber Attack") {
      return yellowIcon;
    } else if (maintenanceStatus) {
      return blueIcon;
    } else if (locationStatus === "Faulted") {
      return redIcon;
    } else {
      // locationStatus === "Available" OR default
      return greenIcon;
    }
  };

  return (
    <AdvancedMarker
      anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
      className={`main-screen-marker main-screen-marker-${determineMarkerColor(
        data.locationStatusType.codeName,
        data.maintenanceActive
      )}`}
      position={position}
      // title={data.locName}
      zIndex={index}
    >
      <MarkerIcon
        src={chooseMarkerIcon(
          data.locationStatusType.codeName,
          data.maintenanceActive
        )}
      />
    </AdvancedMarker>
    // <StandardMarker
    //   anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
    //   className={`main-screen-marker main-screen-marker-${determineMarkerColor(
    //     data.locationStatusType.codeName,
    //     data.maintenanceActive
    //   )}`}
    //   icon={chooseMarkerIcon(
    //     data.locationStatusType.codeName,
    //     data.maintenanceActive
    //   )}
    //   position={position}
    //   zIndex={index}
    // >
    //   {/* <MarkerIcon
    //     src={chooseMarkerIcon(
    //       data.locationStatusType.codeName,
    //       data.maintenanceActive
    //     )}
    //   /> */}
    // </StandardMarker>
  );
};

export default Marker;
